import { apiFetch } from "./client";

export async function createCustomer(payload) {
  return apiFetch("/api/customers", {
    method: "POST",
    body: payload, // ✅ OBJECT
  });
}

// Enhanced customer functions
export async function searchCustomers(query, limit = 10) {
  const params = new URLSearchParams({ 
    q: query, 
    limit: limit.toString() 
  });
  
  return apiFetch(`/api/customers/search?${params}`);
}

export async function getCustomerById(customerId) {
  return apiFetch(`/api/customers/${customerId}`);
}

export async function updateCustomer(customerId, payload) {
  return apiFetch(`/api/customers/${customerId}`, {
    method: "PUT",
    body: payload,
  });
}

export async function deleteCustomer(customerId) {
  return apiFetch(`/api/customers/${customerId}`, {
    method: "DELETE",
  });
}

export async function bulkDeleteCustomers(customerIds, force = false) {
  return apiFetch("/api/customers/bulk", {
    method: "DELETE",
    body: {
      customer_ids: customerIds,
      force: force
    },
  });
}

/** Customers, jobs and unlinked leads matching `q` (name, email, phone, quote number…). */
export function searchEverything(q) {
  return apiFetch(`/api/admin/search?q=${encodeURIComponent(q)}`);
}

/** One customer's jobs, money and dated history. */
export function getCustomerTimeline(customerId) {
  return apiFetch(`/api/admin/customers/${customerId}/timeline`);
}
